import React from 'react';
import { motion } from 'framer-motion';
export function FooterCTA() {
  return <footer className="bg-gradient-to-br from-brand-blue to-blue-900 py-16 relative overflow-hidden" data-id="element-14">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-15">
        <div className="absolute -top-24 -left-24 w-64 h-64 bg-white opacity-5 rounded-full blur-2xl" data-id="element-16" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-green opacity-10 rounded-full blur-3xl" data-id="element-17" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-heading font-bold text-white mb-8 leading-tight" data-id="element-19">
          No sigas postergando tu independencia. Empezá hoy a construir tu
          propio negocio digital.
        </motion.h2>

        <motion.button onClick={() => window.open('https://www.emprende-digital.com/cart/51742249156888:1', '_blank')} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="inline-flex items-center justify-center px-10 py-4 text-lg font-bold text-brand-blue bg-white rounded-full shadow-xl hover:bg-slate-50 transition-colors duration-200 mb-12" data-id="element-20">
          Comprar Ahora
        </motion.button>

        <div className="pt-8 border-t border-blue-800/50" data-id="element-21">
          <p className="text-blue-200 text-sm" data-id="element-22">
            © {new Date().getFullYear()} Emprende Digital. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}